import { jsx } from 'react/jsx-runtime';
import './StateBox.module.scss.js';
import classNames from 'classnames';
import { handleKeyDown } from '../../utils/utils.js';

const StateBox = ({ variant = 'default', hasHoverEffect = false, onClick, className, children, ...rest }) => {
    // Handles keyboard interaction for Enter and Space keys
    return (jsx("div", { className: classNames(`${className}--stateBox`, {
            'box--focused': variant === 'focus',
        }), "data-zta": "stateBox", ...rest, children: jsx("div", { onClick: onClick, onKeyDown: (e) => handleKeyDown(e, onClick), role: "button", tabIndex: 0, className: classNames(className, 'box', {
                'box-with--hover': hasHoverEffect,
                [`box--${variant}`]: variant !== 'focus',
            }), children: children }) }));
};

export { StateBox as default };
//# sourceMappingURL=StateBox.js.map
